import { Box } from "@vp/swan";
import React from "react";

const StickyBox: React.FC<React.PropsWithChildren> = props => {
  return <Box style={{ position: "sticky", top: "20px" }}>{props.children}</Box>;
};

export default StickyBox;
